import React from 'react';
import { withStyles, createStyles, WithStyles } from '@material-ui/styles';
import { Config, withConfig } from '../../config';
import { useLanguage } from 'languages/languageContext';

const styles = createStyles({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginBottom: 30,
  },
  image: {
    maxWidth: '90%',
    height: 'auto',
  },
});

interface Props extends WithStyles<typeof styles> {
  config: Config;
}

const Logo: React.FC<Props> = ({ classes, config }) => {
  const { logoComponent } = useLanguage();

  let logoImg;
  try {
    logoImg = require(`../../assets/logo/logoText_${config.APP_NAME}.png`);
  } catch (error) {
    logoImg = require(`../../assets/logo/logo_${config.APP_NAME}.png`);
  }
  return (
    <div className={classes.container}>
      <img src={logoImg} className={classes.image} alt={''} />
    </div>
  );
};

export default withStyles(styles)(withConfig(Logo));
